module.exports = __webpack_public_path__ + "static/shar_symbol_DND4_FRPG-bcd89f004651fd072fd3e340ec67a524.webp";